module.exports = __webpack_public_path__ + "static/optimum-7c2f26d0ebc3786cb076540c2eee8b59.png";